// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — outline-button.classic.js, новая — outline-button.cp.js
import { isCp } from 'libs/design';
import * as classic from './outline-button.classic';
import * as cp from './outline-button.cp';

export const OutlineButton = isCp ? cp.OutlineButton : classic.OutlineButton;
